import { Fragment } from "react/jsx-runtime";
import HeroSection from "../components/common/HeroSection";
import data from "../programs.json";
import ProgramsOverview from "../components/Programs/OveviewSection";
import HowProgramWorks from "../components/Programs/HowProgramsWork";
import WhyChoosePrograms from "../components/Programs/WhyChosePrograms";
import CTASection from "../components/common/CTASection";
import DigitalHealthFAB from "../components/Digitalhealth";


const { programs, whyChoosePrograms, callToAction } = data;

const Programs = () => {

  const heroSlide = [programs.hero];


  return (
    <Fragment>
      <DigitalHealthFAB/>
      <HeroSection slides={heroSlide} />
      <ProgramsOverview />
      <HowProgramWorks />
      <WhyChoosePrograms data={whyChoosePrograms} />
      <CTASection data={callToAction} />
    </Fragment>
  );
};

export default Programs;